import { RoleInterface } from '../interfaces/role';

export class Role implements RoleInterface {
    id_role?: number;
    value: string;

    constructor() {
        this.value = '';
    }
}